import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter  } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport, Search  } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { Button, Modal, Form, InputGroup, FormControl } from 'react-bootstrap';
import StudentCourseService from '../../service/studentCourseService';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import './CourseStudent.css'

const { ExportCSVButton } = CSVExport;

const errorNotify = (msg) => {
  toast.error(msg, {
    theme: 'dark'
  })
}

const successNotify = (msg) => {
  toast.success(msg, {
    theme: 'dark'
  })
}

export default function CourseStudentTable({ studentCourses }) {
    const data = {
        columns: [
        {
            text: '#',
            dataField: 'index',
            sort: 'asc',
            width: '5%'
        },
        {
            text: 'ปีจบการศึกษา',
            dataField: 'yearOfCourse',
            width: '5%'
        },
        {
            text: 'ชื่อหลักสูตร',
            dataField: 'name',
            width: '10%'
        },
        {
            text: 'รุ่น',
            dataField: 'termOfCourse',
            width: '10%'
        },
        {
            text: 'ปีที่จบ',
            dataField: 'surname',
            width: '10%'
        },
        {
            text: 'คะแนนเฉลี่ย',
            dataField: '-',
            width: '45%'
        },
        {
            text: 'เอกสารสัญญา',
            dataField: '-',
            width: '45%'
        },
        {
            text: 'เอกสารรับรองการจบการศึกษา',
            dataField: '',
            width: '45%'
        },
        ]
    }

    return (
      <>
        <ToolkitProvider
          keyField='id'
          data={ studentCourses }
          columns={ data.columns }
          exportCSV={ { onlyExportFiltered: true, exportAll: false } }
          exportCSV
          search
          exportCSV={ {
            fileName: 'custom.csv',
            noAutoBOM: false,
            blobType: 'text/plain;charset=utf-8',
            exportAll: false
          } }
        >
          {
            props => (
              <div>
                <div className="export-container">
                  <ExportCSVButton className='btn btn-outline-secondary' { ...props.csvProps }>Export CSV!!</ExportCSVButton>
                </div>
                <hr />
                <BootstrapTable
                  { ...props.baseProps }
                  filter={ filterFactory() }
                  hover
                  bordered={ false }
                  noDataIndication="ไม่พบข้อมูล"
                />
              </div>
            )
          }
        </ToolkitProvider>
      </>
    );
}